import {
    CheckIcon,
    ChevronDownIcon,
    ChevronRightIcon,
    ChevronUpIcon,
    CloseIcon,
    Icon,
    SpinnerIcon
} from "@chakra-ui/icons";
import {
    Avatar,
    Box,
    Button, Checkbox, Collapse,
    Divider,
    Flex, FormControl, FormLabel, Heading, IconButton, Input,
    Modal, ModalBody, ModalCloseButton,
    ModalContent, ModalFooter,
    ModalHeader,
    ModalOverlay, Select,
    Text, Textarea, useDisclosure,
    useToast, VStack
} from "@chakra-ui/react";
import {Link, useParams} from "react-router-dom";
import {useSession} from "../../hooks/session";
import {useEffect, useState} from "react";
import * as React from "react";
import {BsWhatsapp} from "react-icons/bs";
import SessionCancelModal from "../../components/sessionCancel";
import {getSessionStatusColor, getSessionStatusDescription, SessionStatus} from "../../enum/session/SessionStatus";
import Report from "../../components/report";
import {format} from "date-fns";
import api from "../../services/api";
import {CheckType} from "../../enum/session-check/CheckType";
import {phoneToWhatsApp} from "../../util/phone-number";
import {Simulate} from "react-dom/test-utils";
import copy from "copy-to-clipboard";
import { Rating } from '@smastrom/react-rating'

import '@smastrom/react-rating/style.css'
import Footer from "../../components/Footer";

interface DeliverablesProps {
}



const DeliverableViewForms: React.FC<DeliverablesProps> = () => {
    const id = useParams().id;
    const sessionD = useSession(id);
    const session = sessionD?.data;

    const [forms, setForms] = useState<any[]>([]);
    const [formValues, setFormValues] = useState<any[]>([]);
    const [loadingIds, setLoadingIds] = useState<number[]>([]);
    const [openIds, setOpenIds] = useState<number[]>([]);

    const toast = useToast();


    useEffect(() => {
        if (session?.id) {
            api.get(`/provider/sessions/${session.id}/forms`)
                .then((response) => {
                    setForms(response.data);

                    // Gera um array/objeto que mapeia form_id → formValues,
                    // convertendo todos os "true"/"false" em boolean
                    const dataI: Array<any> = [];

                    response.data.forEach((formEntry: any) => {
                        const rawProvider = formEntry.form_provider;
                        const coercedProvider: any = {};

                        Object.entries(rawProvider).forEach(([optionId, rawValue]: any) => {
                            // Se for objeto com list interna (grupo de checkboxes)
                            if (rawValue && typeof rawValue === 'object' && rawValue.list) {
                                coercedProvider[optionId] = { list: {} };
                                Object.entries(rawValue.list).forEach(([listKey, listVal]: any) => {
                                    coercedProvider[optionId].list[listKey] =
                                        listVal === 'true'   ? true  :
                                            listVal === 'false' ? false :
                                                listVal;
                                });
                            }
                            // Se veio como string "true"/"false", converte
                            else if (rawValue === 'true') {
                                coercedProvider[optionId] = true;
                            } else if (rawValue === 'false') {
                                coercedProvider[optionId] = false;
                            }
                            // Caso já seja boolean, number ou outro, deixa como está
                            else {
                                coercedProvider[optionId] = rawValue;
                            }
                        });

                        dataI[formEntry.form_id] = coercedProvider;
                    });

                    setFormValues(dataI);
                })
                .catch((err) => {
                    console.error(err);
                });
        }
    }, [session?.id]);

    console.log(formValues)

    useEffect(() => {
        console.log(session)
        if (sessionD?.status && sessionD?.status != 200) {
            toast({
                title: "Erro ao encontrar o ensaio.",
                position: "top-right",
                status: "error",
                duration: 16000,
                isClosable: true,
            });
        }
    }, [sessionD?.status])

    const toggleOpen = (id: number) => {
        setOpenIds(prev =>
            prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
        );
    };

    const handleInputChange = (formId: number, optionId: number | string, value: any) => {
        setFormValues(prev => ({
            ...prev,
            [formId]: {
                ...prev[formId],
                [optionId]: value
            }
        }));
    };
    const saveForm = async (formId: number) => {
        setLoadingIds(prev => [...prev, formId]);
        console.log(formValues)
        try {
            await api.post(`/provider/sessions/${session?.id}/forms/${formId}/save`, {items: formValues[formId]}).then(value => {
                toast({
                    title: "Formulário salvo com sucesso.",
                    position: "top-right",
                    status: "success",
                    duration: 16000,
                    isClosable: true,
                });
            })
        } finally {
            setLoadingIds(prev => prev.filter(id => id !== formId));
        }
    };

    return (
        <Box width={'100%'} maxWidth={'1700px'} mx={'auto'} p={'20px'}>

                <Flex mb={'4'}>
                    <Link to={`/ensaios/${session?.id}`}>
                        <Flex gap={'1.5'} alignItems={'center'}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask0_2023_20012" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                                    <rect width="20" height="20" fill="#D9D9D9"/>
                                </mask>
                                <g mask="url(#mask0_2023_20012)">
                                    <path d="M9.04168 16.0417L3.60418 10.6251C3.50695 10.5278 3.43751 10.4271 3.39584 10.323C3.35418 10.2188 3.33334 10.1112 3.33334 10.0001C3.33334 9.88895 3.35418 9.78131 3.39584 9.67714C3.43751 9.57298 3.50695 9.47228 3.60418 9.37506L9.04168 3.93756C9.20834 3.77089 9.40973 3.68409 9.64584 3.67714C9.88195 3.6702 10.0903 3.757 10.2708 3.93756C10.4375 4.10423 10.5208 4.30909 10.5208 4.55214C10.5208 4.7952 10.4375 5.00006 10.2708 5.16673L6.31251 9.12506H15.4375C15.6736 9.12506 15.8785 9.21187 16.0521 9.38548C16.2257 9.55909 16.3125 9.76395 16.3125 10.0001C16.3125 10.2362 16.2257 10.441 16.0521 10.6146C15.8785 10.7883 15.6736 10.8751 15.4375 10.8751H6.31251L10.2708 14.8334C10.4375 15.0001 10.5243 15.198 10.5313 15.4271C10.5382 15.6563 10.4514 15.8612 10.2708 16.0417C10.1042 16.2084 9.89932 16.2917 9.65626 16.2917C9.41321 16.2917 9.20834 16.2084 9.04168 16.0417Z" fill="#4D5562"/>
                                </g>
                            </svg>
                            <Text fontWeight={'500'} fontSize={'md'}>Produção</Text>
                        </Flex>

                    </Link>
                </Flex>

            <Flex mb={'16'} flexDirection={'column'} shadow={'0px  0px 7px #97A4B6'} borderRadius={'2xl'} padding={'6'}>
                <Flex justifyContent={'space-between'}>
                    <Flex gap={2} alignItems={'start'} flexDirection={'column'}>
                        <Flex alignItems={'center'} gap={'2'}>
                            <Avatar name={session?.client.name} size={'md'} src={session?.client.logo}/>
                            <Text fontWeight={'500'} fontSize={'18px'} color={'gray.600'}>{session?.client.name}</Text>
                        </Flex>
                        <Text fontWeight={'500'} bg={getSessionStatusColor(Number(session?.status))} color={'white'} p={'0.5'} px={'4'} borderRadius={'2xl'}>{getSessionStatusDescription(Number(session?.status))}</Text>
                    </Flex>
                    <Button colorScheme={'whatsapp'} p={'0'} borderRadius={'3xl'}><BsWhatsapp width={'100%'} height={'100%'}/></Button>
                </Flex>

                <Divider my={'4'}/>

                <Flex>
                    <Flex flexDirection={'column'} gap={'0.5'} mt={'3'}>
                        <Text fontWeight={'500'} fontSize={'16px'} color={'gray.400'}>Agendamento</Text>

                        <Text mt={'3'} fontWeight={'500'} fontSize={'16px'}>{session?.scheduled_for && format(new Date(session?.scheduled_for), "HH:mm")} &bull; {session?.scheduled_for && new Date(session?.scheduled_for).toLocaleDateString(
                            "pt-BR",
                            {
                                day: "2-digit",
                                month: "2-digit",
                            }
                        )}</Text>
                    </Flex>
                </Flex>

                <Divider my={'4'}/>

                <Box p={4}>
                    <VStack spacing={6} align="stretch">
                        {forms?.map((form) => (
                            <Box key={form.id} borderWidth="1px" borderRadius="lg" p={4}>

                                <Flex justify="space-between" align="center">
                                    <Heading size="sm">{form?.form?.title}</Heading>
                                    <IconButton
                                        aria-label="Expand"
                                        icon={openIds.includes(form?.form?.id) ? <ChevronUpIcon /> : <ChevronDownIcon />}
                                        onClick={() => toggleOpen(form?.form?.id)}
                                        variant="ghost"
                                    />
                                </Flex>

                                <Collapse in={openIds.includes(form?.form?.id)} animateOpacity>
                                    <VStack spacing={4} mt={4} align="stretch">
                                        {form?.form?.form_options?.map((option: any) => (
                                            <Box key={`opt_${option.id}`}>
                                                {option.type == 0 && (
                                                    <FormControl>
                                                        <Checkbox
                                                            isChecked={formValues?.[form?.form?.id]?.[option.id] || false}
                                                            onChange={(e) =>
                                                                handleInputChange(form?.form?.id, option.id, e.target.checked)
                                                            }>
                                                            {option.title}
                                                        </Checkbox>
                                                    </FormControl>
                                                )}

                                                {option.type === 2 && (
                                                    <FormControl>
                                                        <FormLabel>{option.title}</FormLabel>
                                                        <Input
                                                            value={formValues?.[form?.form?.id]?.[option.id] || ''}
                                                            onChange={(e) =>
                                                                handleInputChange(form?.form?.id, option.id, e.target.value)
                                                            }
                                                        />
                                                    </FormControl>
                                                )}

                                                {option.type === 3 && (
                                                    <FormControl>
                                                        <FormLabel>{option.title}</FormLabel>
                                                        <Textarea
                                                            value={formValues?.[form?.form?.id]?.[option.id] || ''}
                                                            onChange={(e) =>
                                                                handleInputChange(form?.form?.id, option.id, e.target.value)
                                                            }
                                                        />
                                                    </FormControl>
                                                )}

                                                {option.type == 4 && (
                                                    <FormControl>
                                                        <FormLabel>{option.title}</FormLabel>
                                                        <Select
                                                            value={formValues?.[form?.form?.id]?.[option.id] || ''}
                                                            onChange={(e) =>
                                                                handleInputChange(form?.form?.id, option.id, e.target.value)
                                                            }>
                                                            <option value="">-</option>
                                                            {option?.options?.map((opt: any) => (
                                                                <option key={`opti_${opt.identificador}`} value={opt.identificador}>
                                                                    {opt.title}
                                                                </option>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                )}

                                                {option.type == 1 && (
                                                    <Box border="1px solid #E2E8F0" borderRadius="md" p={3}>
                                                        <Heading size="sm" mb={2}>{option.title}</Heading>
                                                        {option?.options?.map((opt: any) => {
                                                            const fieldKey = `${option.id}.list.${opt.identificador}`;

                                                            return (
                                                                <Box key={`optik_${opt.identificador}`} mb={2}>
                                                                    {opt.type == 0 && (
                                                                        <Checkbox
                                                                            isChecked={formValues?.[form?.form?.id]?.[option.id]?.list?.[opt.identificador] || false}
                                                                            onChange={(e) => {
                                                                                const isChecked = e.target.checked;
                                                                                const formId = form?.form?.id;
                                                                                const optionId = option.id;
                                                                                const optIdentificador = opt.identificador;

                                                                                // Certifique-se de que os IDs necessários existem antes de tentar atualizar
                                                                                if (!formId || !optionId || !optIdentificador) {
                                                                                    console.error("IDs necessários para atualização não encontrados.", { formId, optionId, optIdentificador });
                                                                                    return;
                                                                                }

                                                                                setFormValues(prevFormValues => {
                                                                                    // Cria uma cópia profunda para garantir a imutabilidade
                                                                                    // até o nível que precisa ser modificado.
                                                                                    return {
                                                                                        ...prevFormValues, // Copia o nível raiz de formValues
                                                                                        [formId]: {
                                                                                            ...(prevFormValues?.[formId] || {}), // Copia ou inicializa o objeto do formulário específico
                                                                                            [optionId]: {
                                                                                                ...(prevFormValues?.[formId]?.[optionId] || {}), // Copia ou inicializa o objeto da opção específica
                                                                                                list: {
                                                                                                    ...(prevFormValues?.[formId]?.[optionId]?.list || {}), // Copia ou inicializa o objeto list
                                                                                                    [optIdentificador]: isChecked, // Define o valor do checkbox específico
                                                                                                },
                                                                                            },
                                                                                        },
                                                                                    };
                                                                                });
                                                                            }}
                                                                        >
                                                                            {opt.title}
                                                                        </Checkbox>
                                                                    )}

                                                                    {opt.type == 2 && (
                                                                        <FormControl>
                                                                            <FormLabel>{opt.title}</FormLabel>
                                                                            <Input
                                                                                value={formValues?.[form?.form?.id]?.[option.id].list?.[opt.identificador] || ''}
                                                                                onChange={(e) => {
                                                                                    const value = e.target.value;
                                                                                    const formId = form?.form?.id;
                                                                                    const optionId = option.id;
                                                                                    const optIdentificador = opt.identificador;


                                                                                    setFormValues(prevFormValues => {
                                                                                        // Cria uma cópia profunda para garantir a imutabilidade
                                                                                        // até o nível que precisa ser modificado.
                                                                                        return {
                                                                                            ...prevFormValues, // Copia o nível raiz de formValues
                                                                                            [formId]: {
                                                                                                ...(prevFormValues?.[formId] || {}), // Copia ou inicializa o objeto do formulário específico
                                                                                                [optionId]: {
                                                                                                    ...(prevFormValues?.[formId]?.[optionId] || {}), // Copia ou inicializa o objeto da opção específica
                                                                                                    list: {
                                                                                                        ...(prevFormValues?.[formId]?.[optionId]?.list || {}), // Copia ou inicializa o objeto list
                                                                                                        [optIdentificador]: value, // Define o valor do checkbox específico
                                                                                                    },
                                                                                                },
                                                                                            },
                                                                                        };
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </FormControl>
                                                                    )}

                                                                    {opt.type == 3 && (
                                                                        <FormControl>
                                                                            <FormLabel>{opt.title}</FormLabel>
                                                                            <Textarea
                                                                                value={formValues?.[form?.form?.id]?.[option.id].list?.[opt.identificador] || ''}
                                                                                onChange={(e) => {
                                                                                    const value = e.target.value;
                                                                                    const formId = form?.form?.id;
                                                                                    const optionId = option.id;
                                                                                    const optIdentificador = opt.identificador;


                                                                                    setFormValues(prevFormValues => {
                                                                                        // Cria uma cópia profunda para garantir a imutabilidade
                                                                                        // até o nível que precisa ser modificado.
                                                                                        return {
                                                                                            ...prevFormValues, // Copia o nível raiz de formValues
                                                                                            [formId]: {
                                                                                                ...(prevFormValues?.[formId] || {}), // Copia ou inicializa o objeto do formulário específico
                                                                                                [optionId]: {
                                                                                                    ...(prevFormValues?.[formId]?.[optionId] || {}), // Copia ou inicializa o objeto da opção específica
                                                                                                    list: {
                                                                                                        ...(prevFormValues?.[formId]?.[optionId]?.list || {}), // Copia ou inicializa o objeto list
                                                                                                        [optIdentificador]: value, // Define o valor do checkbox específico
                                                                                                    },
                                                                                                },
                                                                                            },
                                                                                        };
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </FormControl>
                                                                    )}
                                                                </Box>
                                                            );
                                                        })}
                                                    </Box>
                                                )}
                                            </Box>
                                        ))}

                                        <Flex justify="flex-end">
                                            <Button
                                                colorScheme="blue"
                                                onClick={() => saveForm(form?.form?.id)}
                                                isLoading={loadingIds.includes(form?.form?.id)}
                                                loadingText="Salvando"
                                            >
                                                Salvar Formulário
                                            </Button>
                                        </Flex>
                                    </VStack>
                                </Collapse>
                            </Box>
                        ))}
                    </VStack>
                </Box>
            </Flex>
            <Footer/>
        </Box>
    );
};

export default DeliverableViewForms;